/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Unchecked-Disabled': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<mask id="svgicon_Unchecked-Disabled_a" fill="#fff"><rect pid="0" width="16" height="16" rx="1"/></mask><rect pid="1" width="16" height="16" rx="1" _fill="#F4F4F4" _stroke="#CFCFCF" stroke-width="3" mask="url(#svgicon_Unchecked-Disabled_a)"/>'
  }
})
